import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import {
  SearchResultImage,
  SearchResultTag,
} from 'app/SearchPage/components/SearchResultCard'

import type { TContentSearchResult } from 'types/content-search'

type DesktopDocumentListCardProps = {
  document: TContentSearchResult
  isSelected: boolean
  onClick: () => void
}

const DesktopDocumentListCard = ({
  document,
  isSelected,
  onClick,
}: DesktopDocumentListCardProps) => {
  return (
    <div
      className={clsx(
        'relative px-4 py-4 border-b cursor-pointer transition-colors',
        // visual left line, does not affect layout width
        'before:content-[""] before:absolute before:left-0 before:top-0 before:h-full before:w-1',
        isSelected
          ? 'bg-blue-5 before:bg-blue-500'
          : 'hover:bg-gray-5 hover:before:bg-gray-300'
      )}
      onClick={onClick}
    >
      <div className="flex space-x-3">
        <div className="flex-none w-12 h-12">
          <SearchResultImage src={document?.thumbnail?.url} isRounded />
        </div>
        <div className="flex flex-col min-w-0">
          <Text variant="action" className="line-clamp-2">
            {document?.title}
          </Text>
          <Text variant="body-sm" color="subdued" className="mt-1 line-clamp-2">
            {document?.description}
          </Text>
          {(document?.tags ?? []).length > 0 && (
            <div className="mt-2">
              {(document?.tags ?? [])
                .filter(
                  ({ icon = '', label = '' }) => Boolean(icon) && Boolean(label)
                )
                .slice(0, 3)
                .map((tag, index) => (
                  <SearchResultTag
                    key={`document-tag-${document?.collectionId}-${index}`}
                    data={{
                      icon: tag.icon,
                      label: tag.label,
                    }}
                  />
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default DesktopDocumentListCard
